import styled from 'styled-components'

export const StatusRuleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;

  width: 100%;
  position: relative;
`

export const StatusItemsWrapper = styled.div`
  display: flex;
  align-items: center;
`
